import { get, isNaN, isFinite } from "lodash"
import { createSelector } from "reselect"
import { STATUSES } from "../../platform/constants"
import { getIsOpPro } from "modules/account-root/selectors"

const { ACTIVE } = STATUSES
const DEFAULT_EZE_PORTFOLIOS = { loading: true, items: [] }
const EMPTY_OBJECT = {}

export const getImporting = state => get(state, "modules.eze.importing")
export const getEzeMetadata = state => get(state, "global.data.ezeMetadata.data")
const getEzePortfoliosRaw = state => get(state, "global.data.ezePortfolios.data")

export const getEzeStatus = createSelector(
  [getEzeMetadata],
  (metadata) => get(metadata, "status"),
)

export const getEzePortfolios = createSelector(
  [getEzePortfoliosRaw],
  (ezePortfolios) => ezePortfolios ? { loading: false, items: ezePortfolios } : DEFAULT_EZE_PORTFOLIOS,
)

export const getEzeConnected = createSelector(
  [getEzeStatus],
  (status) => status === ACTIVE,
)

export const getResourceLimits = createSelector(
  [getEzeMetadata, getIsOpPro],
  (status, isOpPro) => {
    if (!isOpPro) { return }

    const { current, limit } = get(status, "resources", EMPTY_OBJECT)
    return {
      current: isFinite(current) ? current : 0,
      limit: isFinite(limit) ? limit : 0,
      available: isNaN(limit - current) ? 0 : limit - current,
    }
  },
)
